module.exports = __webpack_public_path__ + "media/images/flags/1x1/prk-49cb1093f99d57f0f12aea5977757a1c.svg";